<template>
  <div class="pre-export-content">
    <p class="pre-export-title">{{ getProjectName }}</p>
    <div v-if="projectFetched" class="pre-export-container">
      <div v-for="checkComponent in selectedExportConfig.fieldValue.preExportChecks" :key="checkComponent" class="pre-export-component">
        <component :is="checkComponent" :ref="checkComponent" :projectId="getProjectId" v-on:preExportCheckUpdated="preExportCheckUpdated"/>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/less/colors.less'
import BROSADIdCheck from './checkComponents/BROSADIdCheck.vue'
import BROSADCorrectionReason from './checkComponents/BROSADCorrectionReason.vue'
import SIKBValidationSelector from './checkComponents/SIKBValidationSelector.vue'
import NEN5104Normalization from './checkComponents/NEN5104Normalization.vue'

export default {
  name: 'PreExportCheck',
  components: {
    BROSADIdCheck,
    BROSADCorrectionReason,
    SIKBValidationSelector,
    NEN5104Normalization
  },
  data() {
    return {
      projectFetched: false
    }
  },
  props: {
    selectedExportConfig: {
      type: Object,
      required: true
    }
  },
  async mounted() {
    await this.$store.dispatch('fetchProject', {
      PrID: this.getExportProjects[0].PrID
    })
    this.projectFetched = true
    this.preExportCheckUpdated()
  },
  computed: {
    getExportProjects() {
      return this.$store.getters.getExportInformationExportProjects
    },
    getProjectId() {
      return this.getExportProjects[0].PrID
    },
    getProjectName() {
      return this.getExportProjects[0].PrCode
    }
  },
  methods: {
    preExportCheckUpdated() {
      this.toggleVisibilityForChildComponentsOfSIKBValidationSelector()
    },
    toggleVisibilityForChildComponentsOfSIKBValidationSelector() {
      if (!this.selectedExportConfig.fieldValue.preExportChecks.includes('SIKBValidationSelector')) {
        return
      }

      const hide = !this.getExportProjects[0]?.conversionContext?.broQualityRegime ||
        this.getExportProjects[0]?.conversionContext?.broQualityRegime === 'Undefined'

      if (this.selectedExportConfig.fieldValue.preExportChecks.includes('BROSADCorrectionReason') && this.$refs.BROSADCorrectionReason) {
        this.$refs.BROSADCorrectionReason[0].show = (!hide && this.getExportProjects[0]?.conversionContext?.isCorrection)
      }

      if (this.selectedExportConfig.fieldValue.preExportChecks.includes('BROSADIdCheck') && this.$refs.BROSADIdCheck) {
        this.$refs.BROSADIdCheck[0].show = !hide
      }
    }
  }
}
</script>

<style lang="less">
.pre-export-content {
  width: 90vw;
  height: calc(80vh - 128px);
  padding: 0px 32px;
  overflow-y: scroll;
  .pre-export-title {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 999;
    color: gray800;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    padding: 10px 0px;
  }
  .pre-export-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .bro-check-body {
    display: flex;
    flex-direction: column;
    label {
      font-weight: 500;
    }
    .bro-check-header {
      color: @gray900;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .bro-check-explanation {
      max-width: 650px;
      color: @gray900;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 16px;
    }
    .bro-check-content {
      display: flex;
      flex-direction: row;
      gap: 16px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
</style>
